import type { NodeType } from '@/types/tree/base';

/**
 * Merged into user settings only when initializing the tree from the canonical `/data/{id}` route.
 * Consumers that cannot import modules using the tree store (e.g. `treeNodeTypeConfigs`) should import
 * this symbol from here to avoid circular dependencies.
 */
export const DATA_ROUTE_ROOT_MODE_KEY = '__dataRouteRootMode';

/**
 * When initializing the tree from the canonical `/data/{id}` route, project and publication roots are
 * browse-only shells that list linked data packages — not the full editable project/publication trees.
 */
export function applyCanonicalDataBrowseRootNodeMapping(rootType: NodeType, canonicalDataBrowse: boolean): NodeType {
  if (!canonicalDataBrowse) return rootType;
  if (rootType === 'project') return 'projectInData';
  if (rootType === 'publication') return 'publicationInData';
  return rootType;
}
